import { render, staticRenderFns } from "./coach.vue?vue&type=template&id=7fe3df43&scoped=true"
import script from "./coach.vue?vue&type=script&lang=js"
export * from "./coach.vue?vue&type=script&lang=js"
import style0 from "./coach.vue?vue&type=style&index=0&id=7fe3df43&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fe3df43",
  null
  
)

export default component.exports